import React from "react";
import { Link } from "gatsby";

function MobileNav() {

  return (
    <nav
      className="block lg:flex lg:items-center w-full lg:w-auto h-screen"
    >
      <div className="border-b border-gray-400"></div>
      {[
        {
          route: `/about`,
          title: `About`,
        },
        {
          route: `/contact`,
          title: `Contact`,
        },
        {
          route: `/pricing`,
          title: `Pricing`,
        },
        {
          route: `/faq`,
          title: `FAQ`,
        },   
        {
          route: `/templates`,
          title: `Showcase`,
        },                 
      ].map((link) => (
        <Link
          className="block font-semibold py-4 no-underline mx-auto md:mt-0 font-medium 
            text-gray-700 hover:text-gray-900 transition duration-150 ease-in-out focus:outline-none
            border-b border-gray-400 w-full text-center"
          key={link.title}
          to={link.route}
        >
          {link.title}
        </Link>
      ))}
      <Link
        className="block no-underline w-5/6 mt-4 mx-auto font-semibold text-lg px-6 py-2 text-center
            rounded bg-indigo-600 text-white hover:bg-indigo-700 transition duration-150 ease-in-out focus:outline-none"
        to="/start"
      >
        Get Started
      </Link>
    </nav>
  )
}

export default MobileNav;